<template functional>
  <tr
    :ref="data.ref"
    :class="['TableRowCmp', data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <slot />
  </tr>
</template>

<script>
export default {
  name: 'TableRowCmp',
  functional: true,
};
</script>

<style scoped></style>
